export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Moeda"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Criar relatório"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Resultado da moeda"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Download"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Folha"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Formato de arquivo permitido - xlsx"])}
}